import "./paymentreceiptsssr.js";

function callInitFunction(el) {
  // calls init functions on the given element.
  // needsInit should be the name of the function to call. These functions
  // should be registered in `window`.
  //
  // It will remove `data-needs-init` and add `data-ran-init` attribute to
  // prevent multiple runs of the same init function on the element.
  function getProp(obj, desc) {
    var arr = desc.split(".");
    while (arr.length && (obj = obj[arr.shift()]));
    return obj;
  }
  if (el.dataset.needsInit !== undefined) {
    const fnames = el.dataset.needsInit
    delete el.dataset.needsInit
    el.dataset.needsInitStarted = ''
    el.dataset.needsInitCompleted = ''
    fnames.split(',').map((fname) => {
      el.dataset.needsInitStarted += ',' + fname
      let fn = getProp(window, fname)
      if (fn === undefined) {
        fn = getProp(el, fname);
      }
      if (fn !== undefined) {
        fn(el);
      }
      el.dataset.needsInitCompleted += ',' + fname
    })
  }
};

export function registerInitFunctions() {
  Array.prototype.slice.call(document.querySelectorAll(
    '[data-needs-init]')).map(callInitFunction)
};

window.testNeedsInit = function (el) {
  el.innerHTML = 'Ok'
};

// Width is data-driven per row, so it cannot be a static utility class; set it
// from data-perc here to keep templates free of inline style attributes.
window.setBarWidth = function (el) {
  if (el.dataset.perc !== undefined) {
    el.style.width = el.dataset.perc + '%'
  }
};

function bindSsrModalButton(el, actionName) {
  var modalName = el && el.dataset ? el.dataset.modalTarget : '';
  if (!modalName) return;
  el.addEventListener('click', function () {
    var action = window[actionName];
    if (typeof action === 'function') {
      action(modalName);
    }
  });
}

window.openSsrModal = function (el) {
  bindSsrModalButton(el, 'openModal');
};

window.closeSsrModal = function (el) {
  bindSsrModalButton(el, 'closeModal');
};

window.ctrlClickNewTab = function (el) {
  el.addEventListener('click', function (e) {
    if (!(e.ctrlKey || e.metaKey)) return;
    e.preventDefault();
    e.stopImmediatePropagation();

    var url = el.getAttribute('hx-get');
    if (!url) return;

    var hxVals = el.getAttribute('hx-vals') || '';
    var raw = hxVals.replace(/^js:/, '');
    var params = [];
    raw.replace(/'([^']+)'\s*:\s*'([^']*)'/g, function (_, k, v) {
      params.push(encodeURIComponent(k) + '=' + encodeURIComponent(v));
    });

    var tokenEl = document.querySelector('[name="apitoken"]');
    if (tokenEl) params.push('apitoken=' + encodeURIComponent(tokenEl.value));

    var sep = url.indexOf('?') === -1 ? '?' : '&';
    window.open(url + sep + params.join('&'), '_blank');
  }, true);
};

// init.js
if ('serviceWorker' in navigator) {
  const channel = new BroadcastChannel('smaac');
  let registration = null;
  
  channel.addEventListener('message', (e) => {
    console.log('Client received:', e.data);
    if (e.data.cacheComplete === true) {
      document.dispatchEvent(new CustomEvent('swUpdated', { detail: registration }));
    }
  });
  
  function checkForWaitingServiceWorker() {
    if (registration && registration.waiting) {
      console.log('New service worker is waiting');
      document.dispatchEvent(new CustomEvent('swUpdated', { detail: registration }));
    }
  }
  
  window.addEventListener("load", function() {
    navigator.serviceWorker.register('/sw.js')
      .then((reg) => {
        registration = reg;
        console.log("Service Worker Registered with scope:", reg.scope);
        const rawToken = window.localStorage.getItem("apitoken") 
        const userToken = rawToken ? rawToken.slice(0, 20) : null;
        if (userToken && reg.active) {
          reg.active.postMessage({ type: 'SET_TOKEN', token: userToken });
        }
        checkForWaitingServiceWorker();
        
      })
      .catch((error) => {
        console.error("Service Worker Registration Failed:", error);
      });
  });
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (navigator.serviceWorker.controller) {
      const rawToken = window.localStorage.getItem("apitoken")
      const userToken = rawToken ? rawToken.slice(0, 20) : null;
      if (userToken) {
        navigator.serviceWorker.controller.postMessage({ type: 'SET_TOKEN', token: userToken });
      }
    }
  });
} else {
  console.warn("Service Workers are not supported in this browser.");
}


// --------
// Ensure init functions run on both initial page load and after any HTMX swap.
// Important: do NOT rely on `window.onload` here, because many bundles assign to
// it and can overwrite each other.
(() => {
  // Catch HTMX swaps even if they happen before DOMContentLoaded.
  document.addEventListener('htmx:afterSettle', function () {
    registerInitFunctions();
  });

  const runInitial = () => registerInitFunctions();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runInitial, { once: true });
  } else {
    runInitial();
  }
})()
